var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.13 19.06c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8a4.26 4.26 0 0 0 4.25-4.25 4.26 4.26 0 0 0-4.25-4.25h-11c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h11c3.17 0 5.75 2.58 5.75 5.75s-2.58 5.75-5.75 5.75h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9 11.34 3.34 8.78a.754.754 0 0 1 0-1.06L5.9 5.16c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L4.93 8.25l2.03 2.03c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineUndo);
export default __webpack_public_path__ + "static/media/vuesax-outline-undo.941cbcc33afaf40a4ce193d674d5ff8c.svg";
export { ForwardRef as ReactComponent };